import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { LinkedinCookies } from '@shared/schemas';

import type { CookieField } from '../domain/linkedin-cookies.model';
import { initialState } from './linkedin-cookies.state';

/**
 * LinkedIn-cookies slice. Pure state transitions only; the I/O (load / save)
 * lives in the saga, which dispatches these lifecycle reducers as it progresses.
 */
const slice = createSlice({
  name: 'linkedinCookies',
  initialState,
  reducers: {
    loadStarted: (state) => {
      state.loadStatus = 'loading';
    },
    loaded: (state, action: PayloadAction<LinkedinCookies>) => {
      state.liAt = action.payload.li_at;
      state.jsessionId = action.payload.jsession_id;
      state.cookiesUpdatedAt = action.payload.cookies_updated_at;
      state.loadStatus = 'loaded';
    },
    loadFailed: (state) => {
      state.loadStatus = 'failed';
    },
    fieldChanged: (state, action: PayloadAction<{ field: CookieField; value: string }>) => {
      state[action.payload.field] = action.payload.value;
    },
    saveStarted: (state) => {
      state.saving = true;
    },
    saveSucceeded: (state, action: PayloadAction<string | null>) => {
      state.saving = false;
      state.cookiesUpdatedAt = action.payload;
    },
    saveFailed: (state) => {
      state.saving = false;
    },
    resetCookies: () => initialState,
  },
});

export const linkedinCookiesActions = slice.actions;
export const linkedinCookiesReducer = slice.reducer;
